<template>
    <div class="loader">
        <div class="loader-inner">
            <template v-if="!hideLogo">
                <spinner-gant v-if="currentType == 'gant'" />
                <spinner-vermont v-if="currentType == 'vermont'" />
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: { default: null }, // vermont or gant
        hideLogo: { type: Boolean, default: false }, // vermont or gant
    },

    data() {
        return {
            currentType: this.type,
        };
    },

    created() {
        if (!this.currentType) {
            const bodyElement = document.getElementsByTagName('body')[0];

            if (bodyElement.className.includes('gant')) this.currentType = 'gant';
            if (bodyElement.className.includes('vermont')) this.currentType = 'vermont';
        }
    },
};
</script>

<style lang="scss" scoped>
.loader {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    display: block;
    top: 0px;
    left: 0px;
    z-index: 1000;
}

.loader-inner {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
}
</style>
